import throttle from 'lodash/throttle';

window.throttle = throttle;
